import {userStore} from './userStore'
import Games from "../Components/game/Games";
import * as allGames from "../Components/game/getGame";
import Game from "../Components/game/Game";
import gameGenerate from "../Components/game/gameGenerate";
import {observableStore} from "./obvStore";
import {sessionStore} from "../storage";
const fixDWD=(a,...ks)=>{
    const gn = a.getLottery;
    a.getLottery = (...args)=>{
        if(/\/bet\/(67|66|68|92|7|102|84|85)\/ssc/.test(window.location.pathname)){
            const r= gn.call(a,...args);
            return '||'+r;
        }
        return gn.call(a,...args)
    }
    ks.forEach(k=>{
        const v0 = a[k];
        const v1 = a[k].slice(2);
        Object.defineProperty(a,k,{
            get(){
                if(/\/bet\/(67|66|68|92|7|102|84|85)\/ssc/.test(window.location.pathname)){
                    return v1
                }
                return v0;
            }
        })
    })
};
function gitHs() {
    const dd = {};
    try {
        Object.assign(dd, JSON.parse(sessionStore.getItem('selectHis')))
    } catch (e) {
    }
    return dd;
}

const baseBet = () => ({
    recentGames:[],
    currentPrize:0,
    userGamePrizeGroup: 0,
    curItem: null,
    selectHis: gitHs(),
    changeState: false,
    clickLoading: false,
    bets: 0,
    title: '',
    title_en: '',
    isAdding: false,
    history_gnumber: [],
    available: 0,
    current_number: '',
    current_time: '',
    trace_max_times: 0,
    betInfo: {},
    headerData: [],
    mulriple: 1,//倍数
    mulripleOld: 1,
    max_multiple: 0,
    showGameWayPanel: false,
    playName: '',
    playGame: '',
    type: '',//元角分
    isShow: false,
    info: {},
    wayId: '',
    moneyunit: 1,
    showChange: false,
    countDown: 3,
    time_val: '00:00:00',
    isHistory: false,
    errorMsg: '',
    showErrorPage: false,
    lottery: null
});

export const betStore = observableStore('_be', {
    init() {
        Object.assign(this, baseBet());
    },
    isAct(val, row) {
        const game = this.playGame;
        const {dantuo, balls = []} = game;
        const cells = balls[row] || [];
        const fCells = balls[0] || [];
        const l = cells.length;
        const half = Math.floor(l / 2);
        const oddStart = game.views[0][0] % 2;
        for (let i = 0; i < l; i++) {
            const odd = (i % 2) ^ oddStart;
            switch (val) {
                case '全':
                    if (dantuo) if (fCells[i] !== -1) return
                    if (cells[i] !== 1) return;
                    break;
                case '大':
                    if (dantuo && i >= half) if (fCells[i] !== -1) return;
                    if (cells[i] !== (i >= half ? 1 : -1)) return;
                    break;
                case '小':
                    if (dantuo && i < half) if (fCells[i] !== -1) return;
                    if (cells[i] !== (i < half ? 1 : -1)) return;
                    break;
                case '奇':
                    if (dantuo && odd) if (fCells[i] !== -1) return;
                    if (cells[i] !== (odd ? 1 : -1)) return;
                    break;
                case '偶':
                    if (dantuo && !odd) if (fCells[i] !== -1) return;
                    if (cells[i] !== (!odd ? 1 : -1)) return;
                    break;
                default:
                    return
            }
        }
        return 1;
    },
    clickType(val, row) {
        this.changeState = !this.changeState;
        let {manage} = this;
        let game = manage.getGame(this.playName);
        const {dantuo, balls = []} = game;
        const cells = balls[row] || [];
        const fCells = balls[0] || [];
        const l = cells.length;
        const half = Math.floor(l / 2);
        const oddStart = game.views[0][0] % 2;
        game.limitBets(game.balls, () => {
            for (let i = 0; i < l; i++) {
                const odd = (i % 2) ^ oddStart;
                switch (val) {
                    case '全':
                        if (dantuo) fCells[i] = -1;
                        cells[i] = 1;
                        break;
                    case '大':
                        if (dantuo && i >= half) fCells[i] = -1;
                        cells[i] = i >= half ? 1 : -1;
                        break;
                    case '小':
                        if (dantuo && i < half) fCells[i] = -1;
                        cells[i] = i < half ? 1 : -1;
                        break;
                    case '奇':
                        if (dantuo && odd) fCells[i] = -1;
                        cells[i] = odd ? 1 : -1;
                        break;
                    case '偶':
                        if (dantuo && !odd) fCells[i] = -1;
                        cells[i] = !odd ? 1 : -1;
                        break;
                    case '清':
                        cells[i] = -1;
                        break;
                    default:
                        console.log("文字配置错误");
                        return;
                }
            }
        });
        this.playGame = game;
        this.setBets();
    },
    setHistory({parentId, childId, sonId}) {
        this.selectHis[window.location.pathname] = {
            parentId,
            childId,
            sonId
        };
        sessionStore.setItem('selectHis', JSON.stringify(this.selectHis));
    },
    getHis() {
        return this.selectHis[window.location.pathname] || {};
    },
    chooseGameWay({childId: sonId, parentId, parentId2: childId}) {
        const {max_bet_prize_group, prize_group} = userStore;
        const {userGamePrizeGroup} = this;
        const pg = userGamePrizeGroup || Math.min(prize_group, max_bet_prize_group);
        const {
            headerData,
        } = this;
        let max_multiple = 0;
        let data = headerData || [],
            title = '',
            title_en = '',
            wayId = '';
        if (data.length) {
            if (parentId === undefined) parentId = data[0].id;
        }
        if (parentId) {
            for (let i = 0, len = data.length; i < len; i++) {
                const di = data[i];
                if (di.id === parentId) {
                    title = di.name_cn;
                    title_en = di.name_en;
                }
                if (di.id === parentId && di.children && di.children.length) {
                    if (!childId) {
                        childId = di.children[0].id;
                        sonId = di.children[0].children[0].id;
                    }
                    for (let j = 0, len_j = di.children.length; j < len_j; j++) {
                        const pa = di.children[j];
                        if (pa.id === childId) {
                            title = title + "," + pa.name_cn;
                            title_en = title_en + '.' + pa.name_en;
                        }
                        if (pa.children &&
                            pa.children.length) {
                            for (let k = 0, len_k = pa.children.length; k < len_k; k++) {
                                const chd = pa.children[k];
                                if (childId) {
                                    if (chd.id === sonId) {
                                        title = title + ',' + chd.name_cn;
                                        title_en = title_en + '.' + chd.name_en;
                                        max_multiple = chd.getMaxMultiple(pg);
                                        wayId = chd.id;
                                        break;
                                    }
                                } else {
                                    if (j === 0 && k === 0) {
                                        max_multiple = chd.getMaxMultiple(pg)
                                    }
                                }
                            }
                        }
                    }
                }
            }
            Object.assign(this, {
                title: title,
                title_en: title_en,
                wayId: wayId,
                max_multiple: max_multiple
            });
            this.setHistory({
                parentId,
                childId,
                sonId
            });
            betListStore.setHis([]);
            let playName = this.type + this.getPlayName();
            if (playName !== this.playName) {
                betStore.newStore(playName, this.type)
            }
        }
    },
    getPlayName() {
        const {
            parentId,
            childId,
            sonId
        } = this.getHis();
        const data = this.headerData || [];
        let playName = '';
        for (let i = 0, len_i = data.length; i < len_i; i++) {
            const di = data[i];
            if (di.id === parentId) {
                playName += di.name_en;
                for (let j = 0, len_j = di.children.length; j < len_j; j++) {
                    const ci = di.children[j];
                    if (ci.id === childId) {
                        playName += ci.name_en;
                        for (let k = 0, len_k = ci.children.length; k < len_k; k++) {
                            const ck = ci.children[k];
                            if (ck.id === sonId) {
                                playName += ck.name_en;
                                break;
                            }
                        }
                        break;
                    }
                }
                break;
            }
        }
        return playName;
    },
    newStore(playName, type, noResult) {
        const manage = this.manage;
        if (manage.gameIsContain(playName)) {
            let game = manage.getGame(playName);
            let num = game.getNum(game.balls, game.position);
            Object.assign(this, {
                playGame: game,
                playName: playName,
                bets: num
            });
        } else {
            let nm = playName;
            if (type === '3d' || type === '115') {
                nm = "_" + playName;
            }
            let cfg = allGames[nm] || gameGenerate(nm);
            if (!cfg) {
                Object.assign(this, {
                    playGame: {},
                    playName: '',
                    bets: []
                });
                if ('function' === typeof noResult) noResult();
                return;
            }
            cfg.id = nm;
            let obj = new Game(cfg);
            if ('sscyixingdingweidanfushi' === playName) {
                fixDWD(obj,'balls','views','titles');
            }
            manage.addGame(playName, obj);
            let game = manage.getGame(playName);
            let num = game.getNum(game.balls, game.position);
            Object.assign(this, {
                playGame: game,
                playName: playName,
                bets: num
            })
        }
    },
    ...baseBet(),
    clickBall(x, y) {
        let {manage} = this;
        let game = manage.getGame(this.playName);
        game.limitBets(game.balls, () => {
            if (game.limitBet) {
                for (let i = 0, len = game.balls[x].length; i < len; i++) {
                    if (i === y) {
                        game.balls[x][y] = game.balls[x][y] === 1 ? -1 : 1;
                    } else {
                        game.balls[x][i] = -1;
                    }
                }
            } else if (game.dantuo) {
                let limit = game.dantuoNum, num = 0, last = 0;
                if (x === 0) {//胆码
                    for (let i = 0, len = game.balls[0].length; i < len; i++) {
                        if (i === y) {
                            if (game.balls[0][i] > 0) {
                                game.balls[0][i] = -1;
                                num--;
                            } else {
                                if (num >= limit) {
                                    game.balls[0][last] = -1;
                                } else {
                                    num++;
                                }
                                game.balls[0][i] = 1;
                                game.balls[1][i] = -1
                            }
                        } else {
                            if (game.balls[0][i] > 0) {
                                if (num >= limit) {
                                    game.balls[0][i] = -1;//清理后续
                                } else {
                                    num++;
                                }
                                last = i;
                            }
                        }
                    }
                } else {//拖码
                    game.balls[1][y] = game.balls[x][y] === 1 ? -1 : 1;
                    game.balls[0][y] = -1;
                }
            } else {
                game.balls[x][y] = game.balls[x][y] === 1 ? -1 : 1;
            }
        });
        this.changeState = !this.changeState;
        this.setBets();
    },
    setMoneyunit(v) {
        this.moneyunit = v;
    },
    setData(d) {
        Object.assign(this, d, {selectHis: gitHs()});
        if (this.type) {
            let playName = this.type + this.getPlayName(this.headerData);
            if (playName !== betStore.playName) {
                betStore.newStore(playName, this.type)
            }
        }
        const {childId: parentId2, sonId: childId, parentId} = this.getHis();
        this.chooseGameWay({childId, parentId2, parentId});
    },
    get manage() {
        return Games.getInstance()
    },
    setBets() {
        let game;
        if (this.playName && this.manage)
            game = this.manage.getGame(this.playName);
        this.bets = (game && game.getNum(game.balls, game.position)) || 0
    }
});
export const betListStore = observableStore('_bes', {
    betList: [],
    historyGame: {},
    traceIssues: {},
    traceMax: 1,
    removeFromCart(index) {
        this.betList.splice(index, 1);
    },
    addToCart(ls) {
        this.betList.push(ls);
    },
    setHis(cur) {
        this.historyGame = cur;
    },
    setTrace(cur) {
        this.traceIssues = cur;
    },
    setTraceMax(n) {
        this.traceMax = n;
    }
});
